import React from 'react'
import SideMenu from '../core/SideMenu'
import Header from '@/components/core/Header'
import styled from 'styled-components'
import { FadeIn } from '@/lib/css-lib'
import Loading from '@/components/common/Loading'


export interface WithHeaderTemplateProps {
    mainContent: React.ComponentType<any>
}

const WithHeaderTemplate: React.FC<WithHeaderTemplateProps> = ({ mainContent }) => {
    const Content = mainContent
    return (
        <Container>
            <HeaderItem>
                <Header />
            </HeaderItem>
            <ContentItem>
                <React.Suspense fallback={<Loading />}>
                    <FadeIn>
                        <Content />
                    </FadeIn>
                </React.Suspense>
            </ContentItem>
        </Container>
    )
}

export default WithHeaderTemplate


const Container = styled.div`
    display: grid;
    height: 100vh;
    grid-template-rows: 60px 1fr;
    grid-template-columns: 1fr;
    grid-template-areas:
        'header'
        'content';
`

const HeaderItem = styled.div`
    grid-area: header;
    border: 1px solid #888;
    box-sizing: border-box;
`
const ContentItem = styled.div`
    grid-area: content;
    background-color: ${(p) => p.theme.colors.bgMain};
`